import { Box } from "@material-ui/core";
import { B2BSpinner } from "halifax";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { IFlightListData } from "redmond";
import { RecommendedFlightInfo } from "../RecommendedFlightInfo";
import { RecommendedFlightInfoProps } from "../RecommendedFlightInfo/component";
import { FlightListInfo } from "../FlightListInfo";

interface DesktopFlightListProps
  extends Omit<RecommendedFlightInfoProps, "flight"> {
  faresToShow: IFlightListData[];
  sortedFlights: IFlightListData[];
  flights: any;
  selectedFareId: string;
  isOutgoing: boolean;
  outgoingRecommendedFlight: any;
  returnRecommendedFlight: IFlightListData | null | undefined;
  setFetchMoreData: () => void;
}

export const DesktopFlightList = ({
  faresToShow,
  sortedFlights,
  flights,
  selectedFareId,
  isOutgoing,
  outgoingRecommendedFlight,
  returnRecommendedFlight,
  setFetchMoreData,
  expandedFlight,
  maxPriceFilter,
  packagesByOutboundFareSlice,
  packagesByReturnFareSlice,
  fareClassFilter,
  isAgentPortal,
  departureDate,
  returnDate,
  hotelShopDateRange,
  airports,
  rewardsKey,
  isTripDetailsLoading,
  openMobileFlightDetailsModal,
  largestValueAccount,
  expandedFareDetails,
  handleClickAlgomerchTag,
  setOpenModal,
  handleSliceSelect,
  setClickedFareId,
  setExpandedFlight,
  handleFareSelect,
  setOpenMobileFlightDetailsModal,
}: DesktopFlightListProps) => (
  <InfiniteScroll
    dataLength={faresToShow.length}
    next={setFetchMoreData}
    hasMore={faresToShow.length < sortedFlights.length}
    loader={
      <Box className="loading-flights">
        <B2BSpinner classes={["loading-flights-bunny"]} />
      </Box>
    }
  >
    <RecommendedFlightInfo
      flight={isOutgoing ? outgoingRecommendedFlight : returnRecommendedFlight}
      flights={flights}
      selectedFareId={selectedFareId}
      expandedFlight={expandedFlight}
      maxPriceFilter={maxPriceFilter}
      isOutgoing={isOutgoing}
      packagesByOutboundFareSlice={packagesByOutboundFareSlice}
      packagesByReturnFareSlice={packagesByReturnFareSlice}
      fareClassFilter={fareClassFilter}
      isAgentPortal={isAgentPortal}
      departureDate={departureDate}
      returnDate={returnDate}
      hotelShopDateRange={hotelShopDateRange}
      airports={airports}
      rewardsKey={rewardsKey}
      isTripDetailsLoading={!!isTripDetailsLoading}
      openMobileFlightDetailsModal={!!openMobileFlightDetailsModal}
      largestValueAccount={largestValueAccount}
      expandedFareDetails={expandedFareDetails}
      handleClickAlgomerchTag={handleClickAlgomerchTag}
      setOpenModal={setOpenModal}
      handleFareSelect={handleFareSelect}
      setClickedFareId={setClickedFareId}
      setExpandedFlight={setExpandedFlight}
      handleSliceSelect={handleSliceSelect}
      setOpenMobileFlightDetailsModal={setOpenMobileFlightDetailsModal}
    />
    {faresToShow.map((flight, index: number) => {
      // TODO: Filter for not recommended flight
      const flightSliceId = flight.slice;
      const flightSlice = flights.slices[flightSliceId];
      if (
        !flightSlice ||
        flightSliceId === outgoingRecommendedFlight?.slice ||
        flightSliceId === returnRecommendedFlight?.slice
      ) {
        return null;
      }
      const isListView = true;
      const selectedFare =
        flight.fares.find(
          (fare: any) => fare.example?.fare === selectedFareId
        ) || flight.fares[0];

      return (
        <FlightListInfo
          key={flightSlice.id}
          selectedFare={selectedFare}
          showListView={isListView}
          slice={flightSlice}
          flight={flight}
          index={index}
          flights={flights}
          selectedFareId={selectedFareId}
          expandedFlight={expandedFlight}
          fareClassFilter={fareClassFilter}
          maxPriceFilter={maxPriceFilter}
          isOutgoing={isOutgoing}
          packagesByOutboundFareSlice={packagesByOutboundFareSlice}
          packagesByReturnFareSlice={packagesByReturnFareSlice}
          departureDate={departureDate}
          returnDate={returnDate}
          hotelShopDateRange={hotelShopDateRange}
          isTripDetailsLoading={isTripDetailsLoading}
          openMobileFlightDetailsModal={openMobileFlightDetailsModal}
          airports={airports}
          rewardsKey={rewardsKey}
          isAgentPortal={isAgentPortal}
          largestValueAccount={largestValueAccount}
          expandedFareDetails={expandedFareDetails}
          handleClickAlgomerchTag={handleClickAlgomerchTag}
          setOpenModal={setOpenModal}
          handleSliceSelect={handleSliceSelect}
          setClickedFareId={setClickedFareId}
          setExpandedFlight={setExpandedFlight}
          handleFareSelect={handleFareSelect}
          setOpenMobileFlightDetailsModal={setOpenMobileFlightDetailsModal}
        />
      );
    })}
  </InfiniteScroll>
);
